import * as React from 'react';
import {connect} from 'react-redux';
import {IUserProfileProps} from "./IUserProfileProps";
import {IUserProfileState} from "./IUserProfileState";
import InfiniteScroll from "react-infinite-scroll-component";
import Backend from "../../api/Backend";
import {ToastContainer} from "react-toastify";
import fb from "../../assets/images/_fb.png";
import tw from "../../assets/images/_tw.png";
import ins from "../../assets/images/_ins.png";
import share from "../../assets/images/share.png";
import code from "../../assets/images/code.png";

import HeaderComponent from "../../components/homeHeader";
import MenuComponent from "../../components/menuComponent/MenuComponent";

import {
    FacebookShareButton,
    GooglePlusShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    TelegramShareButton,
    WhatsappShareButton,
    PinterestShareButton,
    VKShareButton,
    OKShareButton,
    RedditShareButton,
    TumblrShareButton,
    LivejournalShareButton,
    MailruShareButton,
    ViberShareButton,
    WorkplaceShareButton,
    LineShareButton,
    EmailShareButton,
} from 'react-share';

import {
    FacebookIcon,
    TwitterIcon,
    TelegramIcon,
    WhatsappIcon,
    GooglePlusIcon,
    LinkedinIcon,
    PinterestIcon,
    VKIcon,
    OKIcon,
    RedditIcon,
    TumblrIcon,
    LivejournalIcon,
    MailruIcon,
    ViberIcon,
    WorkplaceIcon,
    LineIcon,
    EmailIcon,
} from 'react-share';

import {
    FacebookShareCount,
    GooglePlusShareCount,
    LinkedinShareCount,
    PinterestShareCount,
    VKShareCount,
    OKShareCount,
    RedditShareCount,
    TumblrShareCount,
} from 'react-share';
import FooterComponent from "../../components/footerComponent/FooterComponent";
import MasonryComponent from "../../components/masonryComponent/MasonryComponent";



const style = {
    height: 30,
    border: "1px solid green",
    margin: 6,
    padding: 8
};


import { Helmet } from 'react-helmet'
import MenuLeftemobile from "../../components/menuLeftMobile/MenuLeftemobile";

class UserProfile extends React.Component<IUserProfileProps, IUserProfileState> {

    constructor(props : IUserProfileProps) {
        super(props);
        this.state = {
                }
    }


    render() {
        return (
            <div>

                <Helmet
                    titleTemplate="%s - Gif تونسي"
                    defaultTitle="Gif تونسي"
                >
                    <title>Mon Profil</title>
                </Helmet>
                <MenuLeftemobile/>
                <HeaderComponent />
                <MenuComponent/>
                <ToastContainer />


                <div className="_difContent">
                    <div className={"container extraContainerHeight"}>
                        {    <div className="_nextprevRow">
                        </div>}
                        <div className="content">
                            <div className="row">
                                <div className="col _info">
                                    <div className="_img">
                                        {this.props.user && this.props.user.photo ?
                                            (this.props.user.photo.includes('graph.facebook.com') ?
                                                    <img src={this.props.user.photo + '?width=500'} alt="gif title "/>
                                                    :<img src={this.props.user.photo} alt="gif title "/>
                                            )
                                            :null}
                                    </div>
                                    <div className="name">
                                        { this.props.user && this.props.user.name ?
                                            this.props.user.name
                                            : null}
                                    </div>
                                    {/*<div className="description">
                                    {this.props.user.displayName}</div>*/}
                                    <div className="follow">
                                        <div className="title">
                                            suivre sur
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <a className="facebook" href="#"> <img src={fb}/></a>
                                            </div>
                                            <div className="col">
                                                <a className="twitter" href="#"> <img src={tw} /></a>
                                            </div>
                                            <div className="col">
                                                <a className="instagram" href="#"> <img src={ins}/></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col _content" style={{
                                    maxWidth : '696px'
                                }}>


                                <MasonryComponent title={'Mes Gifs'} size={3} url={'https://europe-west1-ttgif-3c665.cloudfunctions.net/usergifs?id=' + this.props.user.uid} uid  />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <FooterComponent />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { errorMessage: state.auth.errorMessage ,
        authenticated: state.auth.authenticated ,
        user: state.auth.currentUser
    };
}
export default connect(
    mapStateToProps,null
)(UserProfile);



// WEBPACK FOOTER //
// ./src/containers/userProfile/UserProfile.tsx